import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('RateList', {
    error: (
        <FormattedMessage
            id='front-app/RateList/Notification/Error:title'
            defaultMessage='Rate List Error'
        />
    ),
});

export const rateListNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
